import React from "react";

import { type Impulse, useScope } from "~/tools/impulse";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";
import { Popover, type PopoverProps } from "../../../popover/Popover";
import type { IconButtonSize } from "../../Buttons";
import { useTimeRangeHistory } from "../../time-range-history-utils";

import { TimeRangeSelectorButton } from "./TimeRangeSelectorButton";
import { TimeRangeSelectorContent } from "./TimeRangeSelectorContent";

const RECENTLY_TIME_RANGES_MAX_COUNT = 7;

export interface TimeRangeSelectorProps extends Pick<PopoverProps, "align"> {
	size?: IconButtonSize;
	contextName: string;
	timeRange: Impulse<TimeRange>;
	disabled?: boolean;
	onClear: VoidFunction;
}

export const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
	size,
	contextName,
	timeRange,
	disabled,
	align,
	onClear,
}) => {
	const scope = useScope();
	const [isOpen, setIsOpen] = React.useState(false);
	const timeRangeHistory = useTimeRangeHistory();

	return (
		<Popover
			align={align}
			content={(close) => (
				<TimeRangeSelectorContent
					closePopup={close}
					onClear={onClear}
					recentTimeRanges={timeRangeHistory?.getValue(scope).getItems().slice(0, RECENTLY_TIME_RANGES_MAX_COUNT)}
					timeRange={timeRange}
				/>
			)}
			destroyTooltipOnHide
			onToggle={setIsOpen}
			open={isOpen}
			placement="topLeft"
			trigger="click"
		>
			<TimeRangeSelectorButton
				active={isOpen}
				disabled={disabled}
				size={size}
				timeRange={timeRange.getValue(scope)}
				tooltip={`Set the ${contextName} interval`}
			/>
		</Popover>
	);
};
